__turbopack_context__.v({
  "bandKey": "place-comparison-module__7iW2Lq__bandKey",
  "columns": "place-comparison-module__7iW2Lq__columns",
  "context": "place-comparison-module__7iW2Lq__context",
  "heading": "place-comparison-module__7iW2Lq__heading",
  "label": "place-comparison-module__7iW2Lq__label",
  "lineKey": "place-comparison-module__7iW2Lq__lineKey",
  "method": "place-comparison-module__7iW2Lq__method",
  "mountain": "place-comparison-module__7iW2Lq__mountain",
  "oceanVisual": "place-comparison-module__7iW2Lq__oceanVisual",
  "place": "place-comparison-module__7iW2Lq__place",
  "result": "place-comparison-module__7iW2Lq__result",
  "section": "place-comparison-module__7iW2Lq__section",
  "stat": "place-comparison-module__7iW2Lq__stat",
  "statLabel": "place-comparison-module__7iW2Lq__statLabel",
});
